import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {UtilService} from "../../../shared/services/util.service";
import {editRoute, newRouteFemale} from "../../../shared/services/data.service";
import {
    ordensServicoModuleName, TipoOrdemServico, ordensServicoStorage,
    OrdemServicoStatus
} from "../shared/data.service";
import {OrdemServico} from "../shared/ordem-servico.model";
import {Frota} from "../../../bens/frotas/shared/frota.model";
import {Localidade} from "../../../estruturas/localidades/shared/localidade.model";
import {OrdemServicoApiService} from "../shared/ordem-servico-api.service";
import {OrdemServicoService} from "../shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../shared/ordem-servico-navigation.service";
import {localidadesStorage, localidadesQuery} from "../../../estruturas/localidades/shared/data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {LocalidadeNavigationService} from "../../../estruturas/localidades/shared/localidade-navigation.service";
import {LocalidadeApiService} from "../../../estruturas/localidades/shared/localidade-api.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {FormaControleService} from "../../../bens/formas-controle/shared/forma-controle.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {ManutencaoProgramadaService} from "../../manutencao-programada/shared/manutencao-programada.service";
import {ManutencaoProgramadaNavigationService} from "../../manutencao-programada/shared/manutencao-programada-navigation.service";
import {manutencoesProgramadaModuleName} from "../../manutencao-programada/shared/data.service";
import {ServicoApiService} from "../../servicos/shared/servico-api.service";
import {MaterialServicoApiService} from "../../../almoxarifado/materiais/material-servico/shared/material-servico-api.service";
import {MaterialOrdemServicoApiService} from "../../../almoxarifado/materiais/materiais-ordem-servico/shared/material-ordem-servico-api.service";

@Component({
    template: require('./ordem-servico-form.component.html'),
    styles: [require('./ordem-servico-form.component.css')]
})
export class OrdemServicosFormComponent implements OnInit {
    ordemServicosModule: any = ordensServicoModuleName;
    manutencaoProgramadaModule: any = manutencoesProgramadaModuleName;
    formObject: any = new OrdemServico();
    frotaObject: any = new Frota();
    tipoObject: any = {};
    localidadeObject: any = new Localidade();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    statusConcluido: number;

    showTipoOdometro: boolean = true;

    tiposList: any[] = TipoOrdemServico;
    statusList: any[] = OrdemServicoStatus;
    localidadeSelectId: string = 'localidade';
    localidadeQuery: any = localidadesQuery;
    frotaSelectId: string = 'frota';
    frotaQuery: any = frotasQuery;

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    showManutencaoProgramadaLink: boolean = false;

    form: FormGroup;
    ativo = new FormControl('');
    dataEmpenho = new FormControl('');
    dataEntrada = new FormControl('', Validators.required);
    dataSaida = new FormControl('');
    tipo = new FormControl('', Validators.required);
    bem = new FormControl('', Validators.required);
    localidade = new FormControl('', Validators.required);
    numeroEmpenho = new FormControl('');
    problemaInformado = new FormControl('', Validators.required);
    laudo = new FormControl('');
    observacoes = new FormControl('');
    bemText = new FormControl({value: '', disabled: true});

    private complete: boolean = false;

    constructor(
        private _route: ActivatedRoute,
        private _ordemServicosApiService: OrdemServicoApiService,
        private _ordemServicosService: OrdemServicoService,
        private _ordemServicosNavigationService: OrdemServicoNavigationService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _localidadeApiService: LocalidadeApiService,
        private _localidadeNavigationService: LocalidadeNavigationService,
        private _frotaNavigationService: FrotaNavigationService,
        private _formaControleService: FormaControleService,
        private _manutencaoProgramadaService: ManutencaoProgramadaService,
        private _manutencaoProgramadaNavigationService: ManutencaoProgramadaNavigationService,
        private _servicoApiService: ServicoApiService,
        private _materialServicoApiService: MaterialServicoApiService,
        private _materialOrdemServicoApiService: MaterialOrdemServicoApiService,
        private _ordemServicoService: OrdemServicoService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            dataEmpenho: this.dataEmpenho,
            dataEntrada: this.dataEntrada,
            dataSaida: this.dataEntrada,
            tipo: this.tipo,
            bem: this.bem,
            localidade: this.localidade,
            numeroEmpenho: this.numeroEmpenho,
            problemaInformado: this.problemaInformado,
            laudo: this.laudo,
            observacoes: this.observacoes,
            bemText: this.bemText
        });
    }

    ngOnInit() {
        let t: any = this._ordemServicosService.getStatusConcluido();
        this.statusConcluido = t.Key;

        this.testSession();
        this.testFrotaBackHistory();
    }

    clickGoToList() {
        this._manutencaoProgramadaService.clearSessionStorage();
        this.goToList();
    }

    clickGoToDetail() {
        this.goToDetail();
    }

    clickCancel() {
        let id = +this._route.snapshot.params['id'];
        if (id) {
            this.goToDetail();
        } else {
            this.goToList();
        }
    }

    clickComplete() {
        this.complete = true;
        swal({
                title: "Você deseja realmente concluir esta manutenção?",
                text: "Esta operação não poderá ser desfeita!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Concluir",
                cancelButtonText: "Fechar",
                closeOnConfirm: false
            },
            function() {
                if (this.formObject.dataSaida && this.formObject.laudo && this.formObject.odometroHorimetroValue) {
                    this.onSend(this.form);
                } else {
                    swal({
                            title: "Dados incompletos para concluir a manutenção",
                            text: "Para concluir a manutenção informe o laudo, a data de saída e o odômetro/horímetro!",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Informar dados",
                            cancelButtonText: "Fechar",
                            closeOnConfirm: false
                        },
                        function() {
                            swal.close();
                        }.bind(this)
                    );
                }
            }.bind(this)
        );
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    clickGoToManutProg() {
        this._manutencaoProgramadaService.clearSessionStorage();
        this._manutencaoProgramadaNavigationService.goToList();
    }

    onSubmit(evt: any) {
        this.complete = false;
        this.onSend(evt);
    }

    getLocalidadeObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._ordemServicosService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                localidade: object.text,
                form: ordensServicoStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, localidadesStorage);
            this._localidadeNavigationService.goToNew();
        } else {
            this.localidadeObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'localidade', object);
        }
    }

    getFrotaObject(object: any) {
        this.frotaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'bem', object);

        this.changeFormaControle();
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.bem = this.frotaObject;
        object.localidade = this.localidadeObject;
        object.tipo = this.tipoObject.Key;

        return object;
    }

    private onSend(evt) {
        this.submitted = true;

        if(evt.valid) {
            //this.btnSaveDisabled = true;
            var object: any = this._utilService.cloneObject(this.formObject),
                date: any;

            if (this.frotaObject.id) {
                object.bemId = this.frotaObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.localidadeObject.id) {
                object.localidadeId = this.localidadeObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.tipoObject.Key) {
                object.tipo = this.tipoObject.Key;
            }

            if (object.status) {
                object.status = object.status;
            }

            object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
            delete object['odometroHorimetroValue'];
            if (!object.odometroHorimetro) {
                object.odometroHorimetroId = null;
            }

            date = document.getElementById('dataEntrada');
            if (date.value) {
                object.dataEntrada = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataEntrada = null;
            }

            date = document.getElementById('dataSaida');
            if (date.value) {
                object.dataSaida = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataSaida = null;
            }

            if (this.complete) {
                let statusConcluido: any = this._ordemServicoService.getStatusConcluido();
                object.status = statusConcluido.Key;
            }

            if (this.formObject.id) {
                this.onEditOrdemServicos(object);
            } else {
                object.status = this._ordemServicosService.getStatusAtivo();
                object.status = object.status.Key;
                this.onAddOrdemServicos(object);
            }
        }
    }

    private onAddOrdemServicos(object: OrdemServico) {
        this._ordemServicosApiService.onPost(object, this.onDone);
    }

    private onEditOrdemServicos(object: OrdemServico) {
        this._ordemServicosApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                if (this.complete) {
                    swal("Sucesso!", "A manutenção foi concluída com sucesso.", "success");
                } else {
                    this._utilService.swalMessageEditSuccess();
                }
                this.goToDetail(Response.id);

            } else {
                this._utilService.swalMessageAddSuccess();

                if (this.showManutencaoProgramadaLink) {
                    this.saveServicos(Response.id);
                } else {
                    this.goToDetail(Response.id);
                }
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._ordemServicosApiService.onGetById(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._ordemServicosService.getSessionStorage();
        this._ordemServicosService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.tipoObject = this.tiposList[0];
    }

    private setModelToForm() {
        if (this.formObject.dataEntrada) {
            if (this.formObject.dataEntrada.indexOf("/") === -1) {
                this.formObject.dataEntrada = this._utilService.convertDateToString(this.formObject.dataEntrada);
            }
        }

        if (this.formObject.dataEmpenho) {
            if (this.formObject.dataEmpenho.indexOf("/") === -1) {
                this.formObject.dataEmpenho = this._utilService.convertDateToString(this.formObject.dataEmpenho);
            }
        }

        if (this.formObject.localidade) {
            this.localidadeObject = this._utilService.cloneObject(this.formObject.localidade);
            delete this.formObject['localidade'];

            var selectObject:any = {text: this.localidadeObject.localidade, id: this.localidadeObject.id};

            this._autocompleteService.createOptionOnSelect2(this.localidadeSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localidadeSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'localidade', this.localidadeObject);
        }

        if (this.formObject.bem) {
            var text: string = '';
            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
            delete this.formObject['bem'];

            if (this.frotaObject.placa) {
                text = this.frotaObject.placa + ' / ';
            }
            var selectObject:any = {text: text.concat(this.frotaObject.identificacao), id: this.frotaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);
            this.changeFormaControle();
        }

        if (this.formObject.odometroHorimetro) {
            this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
            delete this.formObject['odometroHorimetro'];
        }

        this.tipoObject = this._ordemServicosService.getTipoOrdemServico(this.formObject.tipo);
    }

    private goToList() {
        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencao(this.frotaRoute);
        } else {
            this._ordemServicosNavigationService.goToList();
        }
    }

    private goToDetail(osId?: number) {
        var id: number = this.formObject.id;
        if (osId) {
            id = osId;
        }

        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencaoDetail(this.frotaRoute, id);
        } else {
            this._ordemServicosNavigationService.goToDetail(id);
        }
    }

    private changeFormaControle() {
        this.showTipoOdometro = this._formaControleService.changeFormaControle(this.frotaObject.formaControleId);
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory(this.frotaSelectId);

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        if (this.showFrotaLink) {
            this.getFrotaObject(this.frotaDetailHistory);
        } else {
            this.testManutencaoProgramadaBackHistory();
        }
    }

    private testManutencaoProgramadaBackHistory() {
        const manut = this._manutencaoProgramadaService.getSessionStorage();
        if (manut) {
            this.showManutencaoProgramadaLink = true;

            if (manut.length) {
                this._frotaService.setAutocompleteOption(this.frotaSelectId, manut[0].bem);
                this.getFrotaObject(manut[0].bem);
            }
        }
    }

    private saveServicos(osId: number) {
        const servicos: any[] = this._manutencaoProgramadaService.getSessionStorage();
        var list: any[] = [],
            servicosId: number[] = [];
        servicos.forEach(function(item: any){
            if (item.servico) {
                list.push({
                    descricao: item.servico.descricao,
                    quantidade: 1,
                    valor: item.servico.valor,
                    ordemServicoId: osId,
                    servicoId: item.servico.id,
                    data: new Date(),
                    ativo: true
                });

                servicosId.push(item.servico.id);
            }
        }.bind(this));

        var onDone = (function(Response: any) {
            if (!Response.error) {
                this.saveMateriais(servicosId, osId);
            }
        }.bind(this));

        if (list.length) {
            let obj: any = {ordemServicoId: osId, bemId: this.frotaObject.id, Servicos: list};
            this._servicoApiService.onPostServicosOrdemServico(obj, onDone);
        } else {
            this.goToDetail(osId);
        }
    }

    private saveMateriais(servicos: number, osId: number) {
        var onDone = (function(Response: any) {
            var list: any[] = [];
            Response.forEach(function(item: any){
                if (item.material) {
                    list.push({
                        descricao: item.material.descricao,
                        quantidade: item.quantidade,
                        medidaId: item.material.medidaId,
                        materialId: item.material.id,
                        ordemServicoId: osId,
                        ativo: true
                    });
                }
            }.bind(this));

            let obj: any = {ordemServicoId: osId, Materiais: list};
            this._materialOrdemServicoApiService.onPostMateriaisOrdemServico(obj, onDone2);
        }.bind(this));

        var onDone2 = (function(Response: any) {
            if (!Response.error) {
                this.goToDetail(osId);
            }
        }.bind(this));

        const query: any = {"where": { "servicoId": { "inq": servicos}}};
        this._materialServicoApiService.onGetCustomFilter(query, onDone);
    }
}





/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-form/ordem-servico-form.component.ts
 **/